import React from 'react';
import ui from './ProductAdminDashboard.module.css';

// Page numbers around the current page, with gaps shown as ellipses
function pageItems(page, pages) {
  const items = [];
  for (let n = 1; n <= pages; n += 1) {
    if (n === 1 || n === pages || Math.abs(n - page) <= 1) items.push(n);
    else if (items[items.length - 1] !== '…') items.push('…');
  }
  return items;
}

export default function Pagination({ page, pageSize, total, onChange }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <nav className={ui.pagination} aria-label="Pagination">
      <span className={ui.paginationInfo}>Showing {from}–{to} of {total}</span>
      <div className={ui.paginationButtons}>
        <button type="button" className={ui.pageButton} disabled={page <= 1} onClick={() => onChange(page - 1)}>Previous</button>
        {pageItems(page, pages).map((item, index) => (item === '…'
          ? <span key={`gap-${index}`} className={ui.pageGap}>…</span>
          : (
            <button
              key={item}
              type="button"
              className={`${ui.pageButton} ${item === page ? ui.pageButtonActive : ''}`}
              aria-current={item === page ? 'page' : undefined}
              onClick={() => onChange(item)}
            >
              {item}
            </button>
          )))}
        <button type="button" className={ui.pageButton} disabled={page >= pages} onClick={() => onChange(page + 1)}>Next</button>
      </div>
    </nav>
  );
}
